import type { ColumnDef } from "@tanstack/react-table";

import { formatDependencyColumn } from "./formatters/format-dependency-column";
import { formatEPSSColumn } from "./formatters/format-epss-column";
import { formatRootColumn } from "./formatters/format-root-column";
import { formatStatusColumn } from "./formatters/format-status-column";

import type { IPackage } from "../types";
import { timeFromNow } from "utils/format-helpers";
import { translate } from "utils/translations/translate";

const getTableColumns = (): ColumnDef<IPackage>[] => [
  {
    accessorKey: "name",
    cell: formatDependencyColumn,
    header: "Dependency",
    minSize: 320,
  },
  {
    accessorKey: "version",
    enableSorting: false,
    header: translate.t("group.toe.packages.currentVersion"),
  },
  {
    accessorFn: (row): string | null =>
      row.healthMetadata?.latestVersion ?? null,
    enableSorting: false,
    header: translate.t("group.toe.packages.latestVersion"),
    id: "metadataLatestVersion",
    minSize: 120,
  },
  {
    accessorKey: "root.nickname",
    cell: formatRootColumn,
    enableSorting: false,
    header: translate.t("group.toe.packages.root"),
    id: "rootNickname",
    minSize: 150,
  },
  {
    accessorKey: "vulnerable",
    cell: formatStatusColumn,
    enableSorting: false,
    header: translate.t("group.toe.packages.status"),
    minSize: 180,
  },
  {
    accessorKey: "epss",
    cell: formatEPSSColumn,
    enableSorting: false,
    header: "% EPSS",
    minSize: 90,
  },
  {
    accessorFn: (row): string | null =>
      row.healthMetadata?.latestVersionCreatedAt ?? null,
    cell: (cell): string => timeFromNow(cell.getValue<string>()),
    enableSorting: false,
    header: translate.t("group.toe.packages.lastPublished"),
    id: "metadataLatestVersionCreatedAt",
    minSize: 120,
  },
];

export { getTableColumns };
